export default __webpack_public_path__ + "static/media/qrcode.7cef57b4.jpg";